<template>
  <div>
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />

    <div class="ma-4" v-show="!showSkeleton">
      <div class="text-h4">Atualizar Webhook - {{ description }}</div>
    </div>
    <div v-if="canRender">
      <CadastroWebHooks edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import webhooksStore from '../_store'

import CadastroWebHooks from './CadastroWebHooks'

export default {
  name: 'AtualizarWebHook',
  props: {
    _id: String,
  },
  components: { CadastroWebHooks, SkeletonLoaderTitleUpdate },

  data: () => ({
    description: '',
    showSkeleton: false,
    canRender: false,
  }),

  computed: {
    ...mapGetters('atualizarWebhookModulePABXStore', ['getSpecificWebhook']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarWebhookModulePABXStore', webhooksStore)

    await this.listarWebhookEspecifico(this._id)
    this.description = this.getSpecificWebhook.description

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarWebhookModulePABXStore', ['listarWebhookEspecifico']),
  },
}
</script>
